import { createAction } from 'redux-actions';
import { Gruser } from '../../types/papi';

export const fetchGruserSuccess = createAction(
  '@@gruser.GRUSER.FETCH.SUCCESS',
  (gruser: Gruser) => ({
    gruser,
  })
);
